import { initPopover, showPopover, hidePopover, hideModal } from '../core/bootstrap-helpers.js';

export function resizeStickyContent() {
    const $stickyNavbar = $('.sticky-navbar');
    const $addMargin = $('#elite-extra-bar').length ? 0 : 15;

    if ($stickyNavbar.length) {
        const navbarHeight =
            $stickyNavbar.find('.navbar-wrapper').height() + $addMargin;
        $('#wrap').css('margin-top', `${navbarHeight}px`);
    }
}

export function buttonAnimation() {
    $(document).on(
        'click',
        '.btn:not(.btn-empty), #top-navbar .navbar-nav > li > a, #top-navbar-mobile .navbar-nav > li > a, #bottom-navbar .navbar-nav > li > a',
        function (e) {
            var $button = $(this);
            var $div = $('<div/>');
            var btnOffset = $(this).offset();
            var xPos = e.pageX - btnOffset.left;
            var yPos = e.pageY - btnOffset.top;

            $div.addClass('ripple-effect');
            var $ripple = $('.ripple-effect');

            $ripple.css('height', $(this).height());
            $ripple.css('width', $(this).height());

            $div.css({
                position: 'absolute',
                top: yPos,
                left: xPos,
            }).appendTo($(this));

            setTimeout(function () {
                if ($button.find('.ripple-effect').length) {
                    $button.find('.ripple-effect').remove();
                }
            }, 1000);
        }
    );
}

export function initFeedback() {
    var $feedbackButton = $('.toggle-feedback');

    if ($feedbackButton.length) {
        var ticket = new Ticket();
        ticket.initForm();

        initPopover($feedbackButton);

        $feedbackButton.click(function (e) {
            var $icon = $feedbackButton.find('i');
            var newIcon = 'fa-times';
            var status = 'true';

            if ($feedbackButton.attr('data-popover-open') == 'false') {
                showPopover($feedbackButton);
                var $popover = $feedbackButton.next('.popover');

                if (
                    typeof $.fn.velocity !== 'undefined' &&
                    $feedbackButton.attr('data-easein')
                ) {
                    $popover.velocity(
                        'transition.' + $feedbackButton.attr('data-easein')
                    );
                } else {
                    $popover.stop(true, true).fadeIn(150);
                }
            } else {
                hidePopover($feedbackButton);
                newIcon = 'fa-comment';
                status = 'false';
            }

            $feedbackButton.attr('data-popover-open', status);

            $.when($icon.fadeOut(250)).done(function () {
                $icon
                    .removeClass('fa-comment fa-times')
                    .addClass(newIcon)
                    .fadeIn(250);
            });
        });

        $('.feedback-modal').on('show.bs.modal', function () {
            var $icon = $feedbackButton.find('i');

            $feedbackButton.attr('data-popover-open', 'false');
            hidePopover($feedbackButton);

            $.when($icon.fadeOut(250)).done(function () {
                $icon
                    .removeClass('fa-times')
                    .addClass('fa-comment')
                    .fadeIn(250);
            });
        });
    }
}

export function ajaxAlert(element, message) {
    if (element.length && message.length > 0) {
        element.html(
            '<div class="alert alert-success alert-dismissible" role="alert"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                message +
                '</div>'
        );

        setTimeout(function () {
            element.find('.alert').fadeOut(function () {
                element.empty();
                var $modal = element.closest('.modal');
                hideModal($modal);

                if (!$modal.find('form').hasClass('order-modal-form')) {
                    $modal.find('[type="submit"]').removeAttr('disabled');
                }
            });
        }, 3000);
    }
}
